import {Component, OnInit} from '@angular/core';
import {InformationsService} from '../../services/informations.service';
import {Information} from '../../model/information';

import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {InfoTypePipe} from "../../components/common/InfoTypePipe";
import {InfoBlockComponent} from "../../components/common/info-block/info-block.component";
import {DashBlockNewsComponent} from "../../components/user/dash-block/dash-block-news/dash-block-news.component";

@Component({
    selector: 'app-informations',
    imports: [
    BreadcrumbComponent,
    FaIconComponent,
    InfoTypePipe,
    InfoBlockComponent,
    DashBlockNewsComponent
],
    templateUrl: './informations.component.html',
    styleUrls: ['./informations.component.css']
})
export class InformationsComponent implements OnInit {

  infos: Information[];
  search = '';

  constructor(private informationService: InformationsService) {
  }

  ngOnInit(): void {
    this.informationService.getObjects().subscribe(data => {
      this.infos = data.filter(info => !info.draft);
    });
  }

}
